const __WEBPACK_NAMESPACE_OBJECT__ = require("git-url-parse");;